import { getStore } from "../store/store";

export default function getIsTeamsHighContrast(): boolean {
    return getStore().isTeamsHighContrast;
}
